<template>
    <div class="main-content">
        <b-card no-body class="shadow-none bg-transparent">
            <date-picker></date-picker>
        </b-card>
        <card-loader v-if="loading" height="150px" class="mt-3"/>
        <score-participation-evolution-chart
            v-else-if="records.length"
            :dates="dates"
            :score="score"
            class="mt-3"
        />
        <list
            :columns="columns"
            :rows="records"
            :select-options="{
                enabled: false,
            }"
            :pagination-options="{
                perPage: 20,
            }"
            :loading="loading"
            class="mt-3"
        />
    </div>
</template>

<script>
import api from '@/api/api'
import auth from '@/firebase/auth'

export default {
    name: 'ScoreEvolutionReport',
    components: {
        CardLoader: () => import('@/components/Loaders/CardLoader'),
        DatePicker: () => import('@/components/datePicker'),
        List: () => import('@/components/List/List'),
        ScoreParticipationEvolutionChart: () => import('@/components/Charts/ScoreParticipationEvolutionChart'),
    },
    data () {
        return {
            dates: [],
            loading: false,
            participation: [],
            records: [],
            score: [],
            columns: [
                {
                    label: 'Data e Hora',
                    field: 'date',
                    type: 'date',
                    dateInputFormat: 'yyyy-MM-dd HH:mm:ss',
                    dateOutputFormat: 'dd/MM/yyyy HH:mm',
                    thClass: 'text-center',
                    tdClass: 'text-center',
                },
                {
                    label: 'Média (0 a 100)',
                    field: 'average',
                    type: 'number',
                    thClass: 'text-center',
                    tdClass: 'text-center',
                },
                {
                    label: 'Incrível',
                    field: 'responseCounterByIndex.3',
                    type: 'number',
                    thClass: 'text-center',
                    tdClass: 'text-center',
                },
                {
                    label: 'Feliz',
                    field: 'responseCounterByIndex.2',
                    type: 'number',
                    thClass: 'text-center',
                    tdClass: 'text-center',
                },
                {
                    label: 'Regular',
                    field: 'responseCounterByIndex.1',
                    type: 'number',
                    thClass: 'text-center',
                    tdClass: 'text-center',
                },
                {
                    label: 'Infeliz',
                    field: 'responseCounterByIndex.0',
                    type: 'number',
                    thClass: 'text-center',
                    tdClass: 'text-center',
                },
            ],
        }
    },
    methods: {
        loadData () {
            this.loading = true
            auth
                .currentUser
                .getIdToken()
                .then((token) => {
                    api
                        .get('/reports/score-evolution', {
                            params: {
                                range: this.range,
                            },
                            headers: {
                                token,
                            },
                        })
                        .then(response => {
                            this.loading = false

                            if (!response.data || !response.data.length) return

                            response.data = response.data.filter(record => record.allResponses.length)
                            this.score = response.data.map(record => record.average)
                            this.dates = response.data.map(record => record.dateChart)
                            this.records = response.data.reverse()
                        })
                })
                .catch(err => console.log(err))
        },
    },
    computed: {
        range () {
            return this.$store.getters['dashboard/range']
        },
    },
    watch: {
        range: {
            immediate: true,
            handler () {
                this.loadData()
            },
        },
    },
}
</script>
